import { useInfiniteQuery, useMutation, useQuery } from 'react-query';

import { useServiceError } from '@/hooks';

import {
  favoriteHelpItem,
  getFavoritesHelpItem,
  getHelpItem,
  listLastHelpItems,
  searchHelpItems,
  unfavoriteHelpItem,
} from './HelpItems.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';
import { FavoritesHelpItemQuery } from './HelpItems.types';
import { DEFAULT_ROWS } from '..';

export function useLastHelpItems() {
  const query = useQuery(['helpitems', 'last'], () => listLastHelpItems());
  useServiceError(query.error);
  return query;
}

export function useSearchHelpItems(search?: string) {
  const query = useQuery(['helpitems', search, 'search'], () =>
    searchHelpItems(search),
  );
  useServiceError(query.error);
  return query;
}

export function useHelpItem(helpItemId: number) {
  const query = useQuery(['helpitems', helpItemId], () =>
    getHelpItem(helpItemId),
  );
  useServiceError(query.error);
  return query;
}

export function ussFavoritesHelpItem(params?: FavoritesHelpItemQuery) {
  return useInfiniteQuery(
    ['helpItems/favorites', { ...params }],
    ({ pageParam }) => {
      const req: FavoritesHelpItemQuery = {
        nextToken: pageParam,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return getFavoritesHelpItem(req);
    },
    {
      getNextPageParam: (lastPage) => lastPage.nextToken,
    },
  );
}

export function useFavoriteHelpItem() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: favoriteHelpItem,
    onSuccess(_, id) {
      notification.success({ message: 'Artigo adicionado aos favoritos!' });

      queryChanel({
        invalidateQueries: [['helpitems', id]],
        removeQueries: [['helpItems/favorites']],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}

export function useUnfavoriteHelpItem() {
  const queryChanel = useQueryChanel();

  return useMutation({
    mutationFn: unfavoriteHelpItem,
    onSuccess(_, id) {
      notification.success({ message: 'Artigo removido dos favoritos!' });

      queryChanel({
        invalidateQueries: [['helpitems', id]],
        removeQueries: [['helpItems/favorites']],
      });
    },
    onError(error) {
      notificationError(error);
    },
  });
}
